import { render, staticRenderFns } from "./yan.vue?vue&type=template&id=5dc03549&scoped=true&"
import script from "./yan.vue?vue&type=script&lang=js&"
export * from "./yan.vue?vue&type=script&lang=js&"
import style0 from "./yan.vue?vue&type=style&index=0&id=5dc03549&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc03549",
  null
  
)

export default component.exports